import React from "react";
import { component_tool, utils_tool } from '@/tool';
import QRCode from 'qrcode.react';
import ProgramCategorySelect from './programDetail/programCategorySelect'
let { WizModal, WizSurveyAudience, WizTypography, WizRow } = component_tool;
let { $$, checkStrLength } = utils_tool;
import { WizClassifySelect, WizDataAuthSelect, WizTableForm,WizVersionTable } from '@/containers/common';
import HighSet from "@/containers/common/highSet";
import './index.less'
import ProgramLogFix from "./programLogFix"; 

//配置项
let componentName = 'program'
let ref_;
const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "课程名称",
    name: "name",
    dataIndex: "name",

    searchItem: {},
    tableItem: {}
  },
  {
    title: "课程编码",
    name: "scoId",
    dataIndex: "scoId",

    searchItem: {},
    tableItem: {}
  },
  {
    title: "课程分类",
    name: "programCategoryNames",
    dataIndex: "programCategoryNames",
    tableItem: {}
  },
  {
    title: "课程分类",
    name: "programCategoryIds",
    dataIndex: "programCategoryIds",
    searchItem: {
      type: 'diy',
      diy: WizClassifySelect,
      returnKey: true,
      wizTreeSelectListProps: {
        itemProps: {
          icon: 'unordered-list',
          title: '课程分类',
          tips: '请勾选所属课程分类'
        },
        treeProps: { checkStrictly: true }
      },
      apiProps: { type: 1 },
      selectProps: {
        placeholder: '请选择课程分类'
      }
    }
  },
  {
    title: "课程来源",
    name: "programSource",
    dataIndex: "programSource",
    dict: [
      { code: 1, codeName: "别克销售" },
      { code: 2, codeName: "雪佛兰销售" },
      { code: 3, codeName: "凯迪拉克销售" },
      { code: 4, codeName: "售后技术" },
      { code: 5, codeName: "售后非技术" },
      { code: 6, codeName: "二手车" },
      { code: 8, codeName: "集团销售" },
      { code: 9, codeName: "校企合作" },
      { code: 10, codeName: "融入辅导_相达" },
      { code: 11, codeName: "融入辅导_申先" },
      { code: 12, codeName: "TAC技术支持" },
      { code: 13, codeName: "其它" },
      { code: 14, codeName: "车工坊" },
      { code: 15, codeName: "德科" },
    ],
    searchItem: {
      type: "select"
      // mode: 'multiple',
    },
  },
  {
    title: "课程来源",
    name: "programSource",
    dataIndex: "programSource",
    tableItem: {},
    dict: [
      { code: 1, codeName: "别克销售" },
      { code: 2, codeName: "雪佛兰销售" },
      { code: 3, codeName: "凯迪拉克销售" },
      { code: 4, codeName: "售后技术" },
      { code: 5, codeName: "售后非技术" },
      { code: 6, codeName: "二手车" },
      { code: 7, codeName: "凯迪新能源" },
      { code: 8, codeName: "集团销售" },
      { code: 9, codeName: "校企合作" },
      { code: 10, codeName: "融入辅导_相达" },
      { code: 11, codeName: "融入辅导_申先" },
      { code: 12, codeName: "TAC技术支持" },
      { code: 13, codeName: "其它" },
      { code: 14, codeName: "车工坊" },
      { code: 15, codeName: "德科" },
      { code: 19, codeName: "别克新能源" }
    ],
  },
  {
    title: "状态",
    name: "status",
    dataIndex: "status",
    tableItem: {},
    dict: [
      { code: 0, codeName: "草稿" },
      { code: 1, codeName: "发布" },
      { code: 2, codeName: "关闭" }
    ],
    searchItem: {
      type: "select"
      // mode: 'multiple',
    },

  },
  {
    title: "截止时间",
    name: "endDate",
    dataIndex: "endDate",
    tableItem: {}
  },
];

this._downQrCode = () => {
  const canvasImg = document.getElementById('qrCode'); // 获取canvas类型的二维码
  const img = new Image();
  img.src = canvasImg.toDataURL('image/png'); // 将canvas对象转换为图片的data url
  let a_link = document.getElementById('down_link');
  a_link.href = img.src
  a_link.download = '课程二维码';
};

const templateConfig = (data) => {
  const { self } = data;
  let valueRows = []

  // const surveyTempConfig = WizVersionTable.Config.configVersioning(self, { apiParams: {} })
  let tableFormProps = {
    showModal: false,
    visible: true,
    selectType: null,
    width: 900,
    initRows: [],
    value: [],
    modalProps: {
      footer: null,
    }
  }
  const _renderBtn = (value, valueRowList) => {
    if (value && value > 0) {
      value = value[0]
    }
    valueRows = valueRowList
  }
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        searchBarProps: {
          cols: {
            xs: 12,
            md: 12,
            xl: 12
          },
          buttonSort: ['add', "delete", 'batchClose', "export"],
          buttons: [
            {
              key: "add",
              custom: true,
              params: { icon: "plus", children: "新增", type: "primary" },
              customOnClick: {
                key: "jumpPage",
                params: {
                  key: "push",
                  pathname: "/program/programList/programDetailAdd"
                }
              }
            },
            {
              key: "delete",
              custom: true,
              needSelect: true,
              params: { icon: "delete", children: "删除", type: "danger" },
              customOnClick: {
                key: "action",
                params: {
                  apiKey: "delete",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  if (!rows) return;
                  if ($$.isArray(rows) && !rows.length) return;
                  // const content = `删除后数据不可恢复，您确定要删除这${
                  //   $$.isArray(rows) ? rows.length : ""
                  // }条课程吗？`;
                  const content = '删除后数据不可恢复，您确定要删除选中的课程吗？'
                  let ids = [];
                  rows.forEach(e => {
                    if (e['rowKey']) {
                      ids.push(e['rowKey']);
                    }
                  });
                  WizModal.confirm({
                    title: '注意', content,
                    onOk: () => {
                      callback && callback({
                        ids
                      })
                    },
                    onCancel() {
                    }
                  });
                  return null
                }
              },
              recordChangeParams: ({ record, rows }) => {
                let disabled = 0;
                if (rows && rows instanceof Array && rows.length > 0) {
                  rows.forEach(item => {
                    let { status } = item;
                    if (status != null && status != 0) {
                      disabled = 1;
                    }
                  })
                } else {
                  disabled = 1;
                }
                return { disabled: disabled }
              }
            },
            {
              key: "batchClose",
              custom: true,
              needSelect: true,
              params: { icon: "into", children: "批量关闭", type: "info" },
              customOnClick: {
                key: "action",
                params: {
                  apiKey: "UpdateProgramStatus",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  if (!rows) return;
                  if ($$.isArray(rows) && !rows.length) return;
                  // const content = `您确定要批量关闭这${
                  //   $$.isArray(rows) ? rows.length : ""
                  //   }条课件？`;
                  const content = '你确定要关闭选中的课件吗？'
                  let ids = [];
                  rows.forEach(e => {
                    if (e['rowKey']) {
                      ids.push(e['rowKey']);
                    }
                  });
                  WizModal.confirm({
                    title: '注意', content,
                    onOk: () => {
                      callback && callback({
                        idList: ids,
                        status: 2
                      })
                    },
                    onCancel() {
                    }
                  });
                  return null
                }
              },
              recordChangeParams: ({ record, rows }) => {
                let disabled = 0;
                if (rows && rows instanceof Array && rows.length > 0) {
                  rows.forEach(item => {
                    let { status } = item;
                    if (status != null && status === 2) {
                      disabled = 1;
                    }
                  })
                } else {
                  disabled = 1;
                }
                return { disabled: disabled }
              }
            },
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          loading: false,
          // expandedRowRender: (record) => {
          //   return (
          //     <>
          //       <WizRow>
          //         <WizTypography.Paragraph strong>课程受众：</WizTypography.Paragraph>
          //       </WizRow>
          //       <WizSurveyAudience surveyAudienceTitle={"适用范围"} labelWidth={4} style={{ width: '90%' }}  data={record['authData'] || {}} />
          //     </>
          //   )
          // }
        },
        rowOperateSort: ['look', 'update', 'releaseOrClose', 'advancedSet', 'QRCode', 'evaluationManagement', 'authSetting', 'versioning','fixProgramLog'],
        rowOperateView: [
          {
            key: 'look',//课程查看
            custom: true,
            params: { children: '查看' },
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/program/programList/programDetailShow'
              }
            }
          },
          {
            key: "update",
            custom: true,
            params: { children: "编辑" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/program/programList/programDetailUpd"
              }
            }
          },
          {
            key: "releaseOrClose",
            custom: true,
            params: { children: "发布" },
            textFormat: {
              recordKey: 'status',
              dirt: { 2: '发布', 1: '关闭', 0: "发布" }
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "UpdateProgramStatus",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要${record['status'] === 1 ? "关闭" : "发布"
                  }该课程吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      status: record['status'] === 1 ? 2 : 1,
                      idList: [record['id']]
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
          {
            key: 'advancedSet',
            custom: true,
            params: { children: '高级设置' },
            customOnClick: {
              key: 'modal',
              params: {
                modalParams: {
                  title: '高级设置',
                  bordered: true,
                  footer: null,
                  destroyOnClose: true,
                  diy: (e) => {
                    return <>
                      <HighSet data={{ record: e.record, bizType: 0 }}
                        changeModal={e.changeModal}
                      />
                    </>
                  },
                  width: 950
                },
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let disabled = false
              if (record && record['status'] === 2) {
                disabled = true
              }
              return { disabled }
            }
          },
          {
            key: "QRCode",
            custom: true,
            params: { children: "二维码" },
            customOnClick: {
              key: 'modal',
              params: {
                modalParams: {
                  title: '课程二维码',
                  footer: null,
                  destroyOnClose: true,
                  diy: (e) => {
                    return <>
                      <h2 align="center">{e.record.name}</h2>
                      <div align='center' style={{ paddingBottom: 20 }}>
                        <QRCode
                          style={{ margin: 20 }}
                          id="qrCode"
                          value={constants.env.sys_get_app_link(`sgmlms://sgmlms/programDetail/${e.record.id}`)}
                          fgColor="#000000" // 二维码的颜色
                        />
                        <br />
                        <a style={{ borderRadius: 3, borderWidth: 1, borderStyle: 'solid', borderColor: '#6faff8', padding: 8 }} id='down_link' onClick={this._downQrCode}>下载二维码</a>
                      </div>
                    </>
                  }
                }
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let disabled = true
              if (record && record['status'] === 1) {
                disabled = false
              }
              return { disabled }
            }
          },
          {
            key: "evaluationManagement",
            custom: true,
            params: { children: "评价管理" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/program/programList/programEvaluation"
              }
            }
          },
          {
            key: 'authSetting',
            custom: true,
            params: { children: '受众设置' },
            customOnClick: {
              key: 'modal',
              params: {
                modalParams: {
                  title: '受众设置',
                  bordered: true,
                  footer: null,
                  destroyOnClose: true,
                  diy: (e) => {
                    return <>
                      <WizDataAuthSelect
                        value={e.record.authData}
                        onSubmit={(values) => { self._saveAuth(values, e.changeModal) }}
                        bizType={0}
                        bizId={e.record.id}
                        changeModal={e.changeModal}
                      />
                    </>
                  },
                  width: 950
                },
              }
            },
            recordChangeParams: ({ record, rows }) => {
              return true
            }
          },
          {
            key: 'versioning',//版本管理
            name: 'WizButton',
            params: {
              children: '版本管理',
              key: 'versioning',
            },
            onClick: (e) => { self.openVersion && self.openVersion(e['record']) },

          },
          {
            key: 'fixProgramLog',
            custom: true,
            params: { children: '修复课程记录' },
            customOnClick: {
              key: 'modal',
              params: {
                modalParams: {
                  title: '修复课程记录',
                  bordered: true,
                 // footer: null,
                  destroyOnClose: true,
                  diy: (e) => {
                    return <>
                      <ProgramLogFix id={e.record.id}
                      {...e}
                      ref={r => {
                        ref_ = r && r.getWrappedInstance();
                      }}
                      />
                    </>
                  },
                  onOk: () => {
                    ref_._fixProgramLogSubmit()
                  },
                  onCancel: () => {
                  },
                  width: 1000
                },
              }
            },
            recordChangeParams: ({ record, rows }) => {
              return true
            }
          },
        ],
        commonOperate: {
        },
        showAuth: {
          title: '适用范围',
          dataIndex: 'authData'
        }
      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/getListByPage`,
    payload: {
      key: `${componentName}@listByPage`,
      apiParams: { pageNum: 1, pageSize: 10 }
    }
  }
  ,
  add: {
    path: `${componentName}/add`,
    payload: {
      key: `${componentName}@add`,
      apiParams: {}
    }
  },
  update: {
    path: `${componentName}/update`,
    payload: {
      key: `${componentName}@update`,
      apiParams: {}
    }
  },
  delete: {
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
      apiParams: {}
    }
  },
  UpdateProgramStatus: {
    path: `${componentName}/UpdateProgramStatus`,
    payload: {
      key: `${componentName}@UpdateProgramStatus`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  }

}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
